import { Component, OnInit, TemplateRef } from '@angular/core';
import { HomeService } from '../../services/home.service';
import { environment } from 'src/environments/environment';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AlertService } from 'src/app/core/services/alert.service';
import { CartService } from 'src/app/cart/services/cart.service';
import { ProductService } from 'src/app/product/services/product.service';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { HomeModuleConsts } from '../../constants';
@Component({
    selector: 'app-recommend-products-slider',
    templateUrl: './recommend-products-slider.component.html',
    styleUrls: ['./recommend-products-slider.component.scss'],
    standalone: false
})
export class RecommendProductsSliderComponent implements OnInit {
  private rxjsSimulator: Subject<any> = new Subject();
  private subscription: Subscription = new Subscription();
  bsModalRef: BsModalRef;
  loading = false
  contentLoaded = false
  sortBy = 'short_desc'
  order = 'asc'
  pageSize = environment.product_listing_page_size;
  profileImagePath = environment.s3_path + '/' + environment.profileFolder
  imagePath = environment.s3_path + '/' + environment.product_image_folder + '/'
  nextPage = 1;
  productList = []
  totalProductPages = 1;
  totalProductCount = 0;
  noRecord = true;
  commonBottonText: any = 'Ok';
  removeProduct = {};
  removeHeading = ''
  popupMessage = ''
  salesRepDetail = {}
  miniCartDetails: any;
  selectedStore: any;
  global_data:any = {};
  product_for_24_hr:any = {};
  flipped: boolean;
  constructor(private homeService: HomeService, private statePersiste: StatePersistService, private productService: ProductService,
    private alertService: AlertService,
    private modalService: BsModalService,
    private cartService: CartService, private router: Router,private googleAnalyticsService: GoogleAnalyticsService) { 
      this.subscription.add(
        // Here you can set your debounce time
        this.rxjsSimulator.pipe(debounceTime(1000)).subscribe((data) => {
            this.qytChange(data['product'], data['qyt'], data['template'],data['template2'], data['type']);
          }
        )
      );
    }

  ngOnInit(): void {
    this.global_data = this.statePersiste.getLocalStorage('global_data')
    this.statePersiste.watchGlobalDataStorage().subscribe(message => {
      this.global_data = this.statePersiste.getLocalStorage('global_data')
    })
    this.productListing()
    this.salesrepDetail()
    this.selectedStore = this.statePersiste.getLocalStorage('selectedStoreAddress')
    this.miniCartDetails = this.statePersiste.getLocalStorage('mini_cart_details')
    this.statePersiste.watchMiniCartDetailChange().subscribe(message => {
      this.miniCartDetails = this.statePersiste.getLocalStorage('mini_cart_details')
    })
    this.statePersiste.watchhomepageRecommendedProductsStorage().subscribe(message => {
      this.productList = [];
      this.nextPage = 1;
      this.totalProductCount = 0;
      this.totalProductPages = 1
      this.productListing()
      this.salesrepDetail()
    })
    
    this.statePersiste.watchSuggestedPRoductListing().subscribe(message => {
      this.productList = [];
      this.nextPage = 1;
      this.totalProductCount = 0;
      this.totalProductPages = 1
      this.productListing()
      this.salesrepDetail()
    })
  }

  notInteretedSuggest(product){
    
    this.productService.notInterestProduct({'product_id': product.product_id, 'recommendation_id':product.recommendation_id, 'bi_tracking_identifier':HomeModuleConsts.BI_TRACKING_IDENTIFIER_NOTINTERESTED})
      .subscribe(
        data => {
          this.productList = this.productList.filter(item => item.product_id !== product.product_id);
          this.salesRepDetail['product_count'] = this.salesRepDetail['product_count'] -1
          this.totalProductCount = this.totalProductCount - 1;
          this.productList = [];
          this.nextPage = 1;
          this.totalProductCount = 0;
          this.totalProductPages = 1
          this.productListing()
          if (this.productList.length == 0){
            this.noRecord = true
          }
        }
      );
  }

  salesrepDetail(){
    this.productService.storeSuggestBanner()
      .subscribe(
        data => {
          if (data.response) {
            console.log('success')
          }

        }
      );
  }
  productListing() {
    const formdata = {
      "sort": this.sortBy, "order": this.order,
      "page_size": this.pageSize,"page": this.nextPage,
    }
    
    this.productService.recommendationProductsSlider(formdata)
      .subscribe(
        data => {
          if (data.response) {
            const product_list = data.response.products;
            this.totalProductCount = data.response.total_prodducts
            this.totalProductPages = data.response.total_pages;
            this.salesRepDetail = data.response
            if (this.totalProductPages < this.nextPage + 1) {
              this.nextPage = null;
            }
            else {
              this.nextPage += 1;
            }

           if (product_list.length === 0) {
              this.noRecord = true;
              this.productList = [];
              this.nextPage = 1;
              this.totalProductCount = 0;
              this.totalProductPages = 1
            }
            else {
              this.noRecord = false;

            }
            for (let i = 0; i < product_list.length; i++) {
              this.productList.push(product_list[i]);
            }
          }
          this.contentLoaded = true;
          this.loading = false;
        }
      );
  }

  onScrollDown() {
    if ((this.nextPage != 1 && this.nextPage !== null) && !this.loading) {
      this.loading = true;
      this.productListing()
    }

  }

  toInteger(value) {
    return parseInt(value)
  }
  popup(template: TemplateRef<any>){
    this.bsModalRef = this.modalService.show(template,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
  }

  async biTrackingcalling(product, trackingid){
    let birecommendObj;
    birecommendObj =  {"sku":product.sku, "bi_recommendation_id" : product.recommendation_id, "bi_tracking_identifier": trackingid}
    
    this.productService.biRecommend(birecommendObj).subscribe(
      data => {})
    
  }

  updateProductarray(product){
    for (let i = 0; i < this.productList.length; i++) {
      if (this.productList[i]['product_id'] == product.product_id) {
        this.productList[i]['qty'] = '1'
      }
    }
  }

  addToCart(product, qyt, template: any, type: any, template2:any,popup_24hr_template:any,check_last_order=true) {
    let dataObj; 
    if (product.qty == '') {
      qyt = '1'
    }

    if (!check_last_order){
      this.bsModalRef.hide();
    }

    this.miniCartDetails = this.statePersiste.getLocalStorage('mini_cart_details')
    if (this.miniCartDetails){
      if (this.miniCartDetails.items_count != '0' && this.miniCartDetails.items_count != ''){
        check_last_order = false
      }
    }

    dataObj = {
      "cart_item": {
        "sku": product.sku,
        "qty": qyt
      },
      "check_last_order":check_last_order,
    }
    
    this.productService.addToCart(dataObj)
      .subscribe(
        async data => {
          if (data.response) {
            this.biTrackingcalling(product, HomeModuleConsts.BI_TRACKING_IDENTIFIER_TOADD)
            this.popupMessage = ''
            if (data.status == 2212) {
              this.updateProductarray(product)
              this.alertService.error(data.response.msg)
            }
            else if (data.status == 1169) {
              for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i]['product_id'] == product.product_id) {
                  this.productList[i]['qty'] = '1'
                  this.productList[i]['back_in_stock'] = '0'
                }
              }
            }
            else if(data.status == 1180){
              localStorage.setItem('closeStorInfoMessage', data.response.msg)
              document.getElementById("openclosedStoreInfo").click();
              this.updateProductarray(product)
            }
            else if (data.status == 1168) {
              for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i]['product_id'] == product.product_id) {
                  this.productList[i]['qty'] = '1'
                  this.productList[i]['back_in_stock'] = '0'
                }
              }
              this.popupMessage = data.response
              this.commonBottonText = "Ok, Don't show this again"
              this.popup(template2)
              
            }
            else if (data.status == 1163) {
              this.alertService.error(data.response)
              this.productList = this.productList.filter(item => item.product_id !== product.product_id);
              
            }

            else if (data.status == 1188) {
              this.product_for_24_hr = product
              this.popupMessage = data.response.split("<br>").join("\n");
              this.commonBottonText = "Confirm"
              this.popup(popup_24hr_template)
            }
            else {
              for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i]['product_id'] == product.product_id) {
                  this.productList[i]['qty'] = String(qyt)
                  this.productList[i]['item_id'] = data.response.item_id
                }
              }
              var storeCount
              storeCount = this.statePersiste.getLocalStorage('selectedStoreAddress')
              if (template && storeCount['totalStoreCount'] > 1){
                this.popup(template)
              }

            }
            this.statePersiste.emitminiCartData('min cart update')

          }

        }
      );
    // Set boolean class on click of add button
  }

  removeItem(product){
    let fordata;
    fordata = {'item_id': product.item_id}
    this.cartService.removeItem(fordata)
      .subscribe(
        data => {
          if (data.response) {
            if(data.status == 1180){
              localStorage.setItem('closeStorInfoMessage', data.response.msg)
              document.getElementById("openclosedStoreInfo").click();
              const currentUrl = this.router.url;
              this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate([currentUrl]);
              });
            }
            else if (data.status == 2212){
              this.alertService.error(data.response)
            }
            else if (data.status == 2211){
              this.alertService.error(data.response)
              this.noRecord = true;
              this.productList = [];
              this.nextPage = 1;
              this.totalProductCount = 0;
              this.totalProductPages = 1
              this.productListing()
              this.salesrepDetail()
            }
            else{
              for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i]['product_id'] == product.product_id) {
                  this.productList[i]['back_in_stock'] = ''
                  this.productList[i]['item_id'] = ''
                }
              }
              this.statePersiste.emitminiCartData('update mini cart')
              this.alertService.success('Product removed.')
            }
            
          }
            
          }

      )

  }
  public send(product, qyt, template,template2: any, type:any): void {
    // uses an ever-changing value in order to always trigger the update
    this.rxjsSimulator.next({'product':product, 'qyt':qyt, 'template':template,'template2':template2, 'type':type});
  }

  qytChange(product, qyt, template,template2: any, type:any) {
    this.statePersiste.amendQtyGoogleanalyticsEvent()
    if (product.item_id !== '') {
      if (qyt == 0){
        for (let i = 0; i < this.productList.length; i++) {
          if (this.productList[i]['product_id'] == product.product_id) {
            this.productList[i]['qty'] = 0
          }
        }
        this.removeItem(product)
      }else{
        this.qytUpdate(product, String(qyt), template)
      }
      
    }
    else {
      for (let i = 0; i < this.productList.length; i++) {
        if (this.productList[i]['product_id'] == product.product_id) {

          this.productList[i]['qty'] = String(qyt)
        }
      }
    }
  }

  qytUpdate(product, qyt, template) {
    this.productService.qytUpdate({ 'item_id': parseInt(product.item_id), 'qty': qyt })
      .subscribe(
        data => {
          if (data.response) {
            this.popupMessage = ''
            if (data.status == 1169) {
              for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i]['product_id'] == product.product_id) {
                  this.productList[i]['qty'] = '1'
                  this.productList[i]['item_id'] = ''
                  this.productList[i]['back_in_stock'] = '0'
                }
              }
            }
            else if (data.status == 2211){
              this.alertService.error(data.response)
              this.noRecord = true;
              this.productList = [];
              this.nextPage = 1;
              this.totalProductCount = 0;
              this.totalProductPages = 1
              this.productListing()
              this.salesrepDetail()
            }
            else if (data.status == 2212){
              this.alertService.error(data.response)
              for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i]['product_id'] == product.product_id) {
                  this.productList[i]['qty'] = data.response.qty
                }
              }
            }
            else if(data.status == 1180){
              localStorage.setItem('closeStorInfoMessage', data.response.msg)
              
             
            for (let i = 0; i < this.productList.length; i++) {
              if (this.productList[i]['product_id'] == product.product_id) {
                this.productList[i]['qty'] = data.response.qty
              }
            }

            const currentUrl = this.router.url;
              this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate([currentUrl]);
              });
            document.getElementById("openclosedStoreInfo").click();
            }
            else if (data.status == 1163) {
              this.alertService.error(data.response)
              this.productList = this.productList.filter(item => item.product_id !== product.product_id);
              
            }
            else {
              for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i]['product_id'] == product.product_id) {
                  this.productList[i]['qty'] = qyt
                }
              }
            }
            this.statePersiste.emitminiCartData('min cart update')

          }

        }
      );
  }

  slideConfig = {
    "slidesToShow": 4,
    "slidesToScroll": 1,
    "dots": false,
    "infinite": true,
    "loop": true,
    "variableWidth": true,
    'responsive': [
      { 'breakpoint': 1700, 'settings': {'slidesToShow': 4}},
      { 'breakpoint': 1281, 'settings': {'slidesToShow': 3}},
      { 'breakpoint': 992, 'settings': {'slidesToShow': 2}},
      { 'breakpoint': 767, 'settings': {
        'slidesToShow': 1,
        "arrows": false,
        "dots": false,
      }}
    ]
  };
 
  flipIt(product) {
    for (let i = 0; i < this.productList.length; i++) {
      if (this.productList[i]['product_id'] == product.product_id) {
        this.productList[i]['flipped'] = !product.flipped
      }
    }
  }

  

}
